"use client";

import Button from "@/app/components/ui/Button";
import FA_LANG from "@/assets/locale/fa";
import Image from "next/image";
import Popover from "@/app/components/ui/Popover";
import { useState } from "react";
import { lessonIcon, activityIcon } from "@/utils/constants";

export default function PageTypeSelector({
  type,
  updatePageType,
  isDesktopOrLaptop,
}: {
  type: string;
  updatePageType: Function;
  isDesktopOrLaptop?: boolean;
}) {
  const [hoverImage, setHoverImage] = useState("/activityImage/Test.png");
  const [popoverTitle, setPopOverTitle] = useState("");

  return (
    <div className="flex w-full p-6 h-fit flex-col items-start gap-3 rounded-xl bg-bg-cards">
      <div className="flex flex-col justify-start gap-3 grow self-stretch">
        <div className="flex flex-col items-start gap-3 self-stretch md:p-0 ">
          <div className="flex flex-col items-start gap-[6px] self-stretch">
            <div className="text-right text-text-title text-base font-extrabold">
              {FA_LANG.SELECT_PAGE}
            </div>
          </div>
          <div className="flex flex-col items-center p-3  gap-3 self-stretch rounded-xl bg-bg-cards1">
            {isDesktopOrLaptop && (
              <div className="text-right text-text-title text-xs font-normal">
                {FA_LANG.ACTIVITY_DESCRIPTION}
              </div>
            )}
            <div className=" flex md:flex-row flex-wrap justify-start items-center gap-3 self-stretch  ">
              {type === "lesson" && (
                <div className="flex md:flex-row flex-wrap  md:p-3 p-3 items-start justify-evenly  gap-[6px] rounded-lg bg-bg-cards2 w-full md:w-[30%] ">
                  {lessonIcon.map((item, index) => (
                    <div
                      key={index}
                      onMouseEnter={() => {
                        setHoverImage(item.image);
                        setPopOverTitle(item.title);
                      }}
                      onMouseLeave={() => {
                        setHoverImage("");
                        setPopOverTitle("");
                      }}
                      title={item.title}
                      className="md:flex grid grid-rows-2 "
                    >
                      <Button
                        icon={item.icon}
                        styleClass={`${item.bg}  p-1 iconbutton`}
                        iconHeight="h-[18px]"
                        iconWidth="w-[18px]"
                        handleClick={() => updatePageType(item.slide_type)}
                      />
                      {!isDesktopOrLaptop && <div>{item.title}</div>}
                      <div className="flex justify-start -mr-10 mt-10">
                        {popoverTitle === item.title && (
                          <Popover title={popoverTitle} />
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              )}
              <div className="flex md:flex-row flex-wrap md:p-3 p-3 items-start gap-[6px] rounded-lg bg-bg-cards2 justify-evenly md:w-[60%] w-full">
                {activityIcon.map((item, index) => (
                  <div
                    key={index}
                    onMouseEnter={() => {
                      setHoverImage(item.image);
                      setPopOverTitle(item.title);
                    }}
                    onMouseLeave={() => {
                      setHoverImage("");
                      setPopOverTitle("");
                    }}
                    className="md:flex grid grid-rows-3"
                  >
                    <Button
                      icon={item.icon}
                      styleClass={`${item.bg}  p-1 iconbutton`}
                      iconHeight="h-[18px]"
                      iconWidth="w-[18px]"
                      handleClick={() => updatePageType(item.quiz_type)}
                    />
                    {!isDesktopOrLaptop && <div>{item.title}</div>}
                    <div className="flex justify-start -mr-10 mt-10">
                      {popoverTitle === item.title && (
                        <Popover title={popoverTitle} />
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      {isDesktopOrLaptop && (
        <div className="flex flex-col justify-center items-center gap-3 grow self-stretch rounded-xl border-2 bg-bg-cards1 h-fit py-20">
          {hoverImage ? (
            <Image
              alt="activityImage"
              src={hoverImage}
              height={132}
              width={530}
            />
          ) : (
            <Image
              alt="activityImage"
              src={"/activityImage/Test.png"}
              height={132}
              width={530}
            />
          )}
        </div>
      )}
    </div>
  );
}
